import { useEffect } from 'react';

export default function useListenSize(dependencies) {
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (window.parent) {
      document.body.style.overflow = 'hidden';
      const calculateScroll = () => {
        const payload = JSON.parse(
          JSON.stringify({
            katapultSDK: 'height',
            katapultSDKHeight: `${document.body.offsetHeight + 25}px`,
          }),
        );
        window.parent.postMessage(payload, '*');
        // Restore to a permanent vertical scrollbar (not 'initial'/visible) so the
        // scrollbar gutter is always reserved. Otherwise the scrollbar appears when
        // a card is open (content overflows) and disappears when closed, changing
        // the viewport width and making the whole page shift/resize on toggle.
        document.body.style.overflowY = 'scroll';
        document.body.style.overflowX = 'hidden';
      };
      setTimeout(calculateScroll, 0);
      setTimeout(calculateScroll, 500);
      setTimeout(calculateScroll, 3000);
      window.addEventListener('resize', calculateScroll);
      return () => window.removeEventListener('resize', calculateScroll);
    }
  }, [dependencies]);
}
